(function () {
  function money(value) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    }).format(Number(value) || 0);
  }

  function pieces(value) {
    return `${Number(value) || 0} Stück`;
  }

  function initPackage(card) {
    const packageKey = card.dataset.b2bPackage;
    const dataNode = card.querySelector('[data-b2b-tiers]');
    if (!packageKey || !dataNode) return;

    let tiers = [];
    try {
      tiers = JSON.parse(dataNode.textContent || '[]');
    } catch (error) {
      console.warn('Firmenpaket-Daten konnten nicht gelesen werden.', error);
      return;
    }
    if (!tiers.length) return;

    let activeTier = tiers[0];
    let activeShape = 'oval';

    const tierButtons = Array.from(card.querySelectorAll('[data-b2b-tier]'));
    const shapeButtons = Array.from(card.querySelectorAll('[data-b2b-shape]'));
    const priceNode = card.querySelector('[data-b2b-price]');
    const compareNode = card.querySelector('[data-b2b-compare]');
    const savingNode = card.querySelector('[data-b2b-saving]');
    const cta = card.querySelector('[data-b2b-cta]');

    function setValue(key, value) {
      const node = card.querySelector(`[data-b2b-value="${key}"]`);
      if (node && value != null) node.textContent = pieces(value);
    }

    function render() {
      tierButtons.forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.b2bTier === activeTier.slug ? 'true' : 'false');
      });
      shapeButtons.forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.b2bShape === activeShape ? 'true' : 'false');
      });

      if (priceNode) priceNode.textContent = money(activeTier.price);
      if (compareNode) compareNode.textContent = money(activeTier.compare);
      if (savingNode) savingNode.textContent = `${money(activeTier.compare - activeTier.price)} sparen`;
      if (cta) {
        const params = new URLSearchParams({ b2b: packageKey, tier: activeTier.slug, shape: activeShape });
    const editorPath = window.location.pathname.endsWith('.html')
      ? 'product.html'
      : '/pages/editor';
    cta.href = `${editorPath}?${params.toString()}`;
        cta.setAttribute('aria-label', `${activeTier.label} ${packageKey === 'office' ? 'Büro-Paket' : packageKey === 'team' ? 'Team-Paket' : 'Sichtbarkeits-Paket'} gestalten`);
      }

      ['stickers', 'mini', 'shirts', 'mugs', 'flags'].forEach((key) => setValue(key, activeTier[key]));
    }

    tierButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const next = tiers.find((tier) => tier.slug === button.dataset.b2bTier);
        if (!next) return;
        activeTier = next;
        render();
      });
    });

    shapeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeShape = button.dataset.b2bShape === 'rect' ? 'rect' : 'oval';
        render();
      });
    });

    render();
  }

  function init() {
    document.querySelectorAll('[data-nett-b2b] [data-b2b-package]').forEach(initPackage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
